import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { useAuth } from "./contexts/authContext";
import { useTranslation } from "react-i18next";

import UserPage from "./pages/user/UserPage";
import UserDetailPage from "./pages/user/UserDetailPage";
import CandidatePage from "./pages/candidate/CandidatePage";
import AddCandidatePage from "./pages/candidate/AddCandidatePage";
import EditCandidatePage from "./pages/candidate/EditCandidatePage";
import { Header } from "./components/header/Header";
import { NavBar } from "./components/navbar/Navbar";
import { Footer } from "./components/footer/Footer";
import LoginPage from "./pages/login/LoginPage";
import { USER_DATA } from "./services/storageService/storageKeys";
import { storageService } from "./services/storageService/storageService";


const RequireAuth = () => {
  const location = useLocation();
  const data = storageService.getData(USER_DATA);
  if(!data?.token) return <Navigate to='/login' state={{ path: location.pathname }}/>
  else return <Outlet/>;
}

const RequireAdmin = () => {
  const auth = useAuth();
  const { t } = useTranslation();
  const location = useLocation();

  const isAdmin = auth?.user?.role === "ADMIN";

  if (!isAdmin) {
    return (
      <Navigate
        to="/candidates"
        replace
        state={{
          toast: { type: "error", message: t("MODAL.NO_PERMISSION") },
          from: location.pathname,
        }}
      />
    );
  }

  return <Outlet />;
};

const RequireNoAuth = () => {
  const location = useLocation();
  const data = storageService.getData(USER_DATA);
  if(!data?.token) return <Outlet/>;
  return <Navigate to='/candidates' state={{ path: location.pathname }}/>
}

const LayoutWithTabs = () => {
  return (
    <>
      <NavBar />
      <Outlet />
    </>
  );
};

const Router = () => {

  const auth = useAuth();

  return(
    <div className='routerContainer flex flex-col min-h-screen'>
      { auth.token && auth.user && <Header /> }
      <div className="container routerContainer-content flex-grow w-full">
        <Routes>
            <Route element={<RequireAuth />}>
                <Route element={<LayoutWithTabs />}>
                    <Route path="/candidates" element={<CandidatePage />} />
                    <Route element={<RequireAdmin />}>
                        <Route path="/users" element={<UserPage />} />
                    </Route>
                </Route>
                <Route path="/add-candidate" element={<AddCandidatePage />} />
                <Route element={<RequireAdmin />}>
                    <Route path="/users/:userId" element={<UserDetailPage />} />
                </Route>
                <Route path="/edit-candidate/:id" element={<EditCandidatePage />} />

            </Route>
            <Route element={<RequireNoAuth />}>
                <Route path="/" element={<LoginPage />} />
            </Route>
            <Route path='*' element={<Navigate to="/" replace/>} />
        </Routes>
      </div>
      { auth.token && auth.user && <Footer /> }
    </div>
  )
}

export default Router;